<template>

    <div>
        <van-divider />
        <van-row >
            <van-col span="17" >
                <span style="color: #969799">支出￥{{pay}} 收入￥{{income}}</span>
            </van-col>
            <van-col span="7" >
                <van-button icon="calender-o" plain type="info" size="small" :text="showDate" @click="showDatePicker = true" color="#fe7844"></van-button>
            </van-col>
        </van-row>
        <van-calendar v-model="showDatePicker" type="range" @confirm="onConfirm" :max-range="30"
                      :min-date="minDate" :max-date="maxDate" :default-date="defaultDate"/>
        <van-divider />
        <fin-month-count @getParData="getParData($event)" :range-date="rangeDate" view-id="rangeCountId"></fin-month-count>
        <fin-month-sort @getParData="getSortData($event)" :range-date="rangeDate" view-id="rangeSortId"></fin-month-sort>
        <fin-sort-detail v-if="qryData.finType == 12101" @getParData="getParData($event)" :range-date="rangeDate" :sort="qryData.sort" :sort-name="qryData.sortName" view-id="rangeSortDetailId"></fin-sort-detail>
        <van-popup v-model="popupShow" round closeable position="bottom" :style="{ width: '100%',height: '80%' }" >
            <popup-fin-list :qry-data="qryData" :refresh-index="refreshIndex"></popup-fin-list>
        </van-popup>
        <div style="margin-bottom: 100px"></div>
    </div>
</template>

<script>
    import FinMonthCount from "./FinMonthCount";
    import FinMonthSort from "./FinMonthSort";
    import PopupFinList from "../report/PopupFinList";
    import * as DateUtil from '@/common/utils/dateUtil.js'
    import * as MyApi from '@/api/URLApiAddr.js'
    export default {
        name: "FinMonthStatistics",
        components: {
            FinMonthCount,
            FinMonthSort,
            PopupFinList
        },
        data() {
            return {
                rangeDate: {
                    startDate: DateUtil.formatDate(DateUtil.dayOfDateNum(-7),'yyyy-MM-dd'),
                    endDate: DateUtil.formatDate(new Date(),'yyyy-MM-dd')
                },
                showDatePicker:false,
                minDate: DateUtil.getMinDate(),
                maxDate: DateUtil.getMaxDate(),
                income: 0,
                pay: 0,
                popupShow: false,
                qryData: {},
                defaultDate: [
                    DateUtil.dayOfDateNum(-7),
                    new Date()
                ],
                showDate : '',
                refreshIndex: 0
            }
        },
        watch:{
            rangeDate(){
                debugger
                this.showDate = this.formatShowDate()
                this.qryMonthInfo()
            }

        },
        mounted(){
            this.showDate = this.formatShowDate()
            this.qryMonthInfo()
        },
        methods: {
            qryMonthInfo() {
                let params = {startDate:this.rangeDate.startDate,endDate:this.rangeDate.endDate}
                this.$axios.post(MyApi.QRY_FIN_MONTH_INFO,params/*,options*/)
                    .then((data) =>  {
                        //let data = response.data
                        if('200' == data.code){
                            let resData = data.data
                            if(resData){
                                this.income = resData.income
                                this.pay = resData.pay
                            }else{
                                this.income = 0
                                this.pay = 0
                            }
                        }

                    })
                    .catch((err) => {

                    })


            },

            showPopup() {
                this.popupShow = true;
            },
            getQryData(qryData) {

                this.popupShow = qryData.popupShow;

            },
            onConfirm(date) {
                debugger;
                const [start, end] = date;
                this.showDatePicker = false;
                //this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
                // this.rangeDate.startDate = formatDate(start,'yyyy-MM-dd')
                // this.rangeDate.endDate = formatDate(end,'yyyy-MM-dd')
                let rangeDate={
                    startDate : DateUtil.formatDate(start,'yyyy-MM-dd'),
                    endDate : DateUtil.formatDate(end,'yyyy-MM-dd')
                }
                this.rangeDate = rangeDate;
            },
            // formatDate(date) {
            //     return `${date.getMonth() + 1}/${date.getDate()}`;
            // },
            formatShowDate(){
                debugger;
                const {startDate, endDate} = this.rangeDate;
                let s = startDate.substr(5,9);
                let e = endDate.substr(5,9);
                return s + '/' + e;
            },
            getParData(childData){
                debugger
                this.qryData = {}
                if(childData.belong){
                    this.qryData.belongs = [childData.belong]
                }
                this.qryData.startDate = this.rangeDate.startDate
                this.qryData.endDate = this.rangeDate.endDate
                this.qryData.finType = childData.finType
                if(childData.sort){
                    this.qryData.sorts = [childData.sort]
                    this.qryData.sort = childData.sort
                }
                if(childData.sortDetail){
                    this.qryData.sortDetail = childData.sortDetail
                }
                this.refreshIndex ++
                this.popupShow = true
            },
            getSortData(childData){
                debugger
                this.qryData = {}

                this.qryData.startDate = this.rangeDate.startDate
                this.qryData.endDate = this.rangeDate.endDate
                this.qryData.finType = childData.finType
                this.qryData.sortName = childData.sortName
                if(childData.sort){
                    this.qryData.sort = childData.sort
                }
                if(childData.detail){
                    this.qryData.details = [childData.detail]
                }
                if(childData.sortDetail || childData.detail){
                    this.refreshIndex ++
                    this.popupShow = true
                }
            }
        }
    }
</script>

<style scoped>

</style>
